<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M51 43a8 8 0 00-6.35 3.15l-24-12a7.75 7.75 0 000-4.34l24-12A8 8 0 1043 13a7.8 7.8 0 00.31 2.17l-24 12a8 8 0 100 9.7l24 12A7.8 7.8 0 0043 51a8 8 0 108-8z"/></svg>